import axios from "axios";

const selicCalculator = async (fromDate, toDate, amount) => {
  try {
    let initialDate = fromDate.split("-").reverse().join("/");
    let endDate = toDate.split("-").reverse().join("/");

    let product = 1;

    let url = `https://api.bcb.gov.br/dados/serie/bcdata.sgs.11/dados?formato=json&dataInicial=${initialDate}&dataFinal=${endDate}`;

    const response = await axios.get(url);

    for (let i = 0; i < response.data.length; i++) {
      product = product * (1 + parseFloat(response.data[i]["valor"]) / 100);
    }

    return product * amount;
  } catch (err) {
    console.error(err);
  }
};

export default selicCalculator;
